export interface Country {
  isoCode: string
  label: string
  dialingCode: number
}

export default [
  // Moving US so most users find their country faster
  { isoCode: 'US', label: 'United States', dialingCode: 1 },
  { isoCode: 'AF', label: 'Afghanistan', dialingCode: 93 },
  { isoCode: 'AX', label: 'Aland Islands', dialingCode: 358 },
  { isoCode: 'AL', label: 'Albania', dialingCode: 355 },
  { isoCode: 'DZ', label: 'Algeria', dialingCode: 213 },
  { isoCode: 'AS', label: 'American Samoa', dialingCode: 1684 },
  { isoCode: 'AD', label: 'Andorra', dialingCode: 376 },
  { isoCode: 'AO', label: 'Angola', dialingCode: 244 },
  { isoCode: 'AI', label: 'Anguilla', dialingCode: 1264 },
  { isoCode: 'AQ', label: 'Antarctica', dialingCode: 672 },
  { isoCode: 'AG', label: 'Antigua and Barbuda', dialingCode: 1268 },
  { isoCode: 'AR', label: 'Argentina', dialingCode: 54 },
  { isoCode: 'AM', label: 'Armenia', dialingCode: 374 },
  { isoCode: 'AW', label: 'Aruba', dialingCode: 297 },
  { isoCode: 'AU', label: 'Australia', dialingCode: 61 },
  { isoCode: 'AT', label: 'Austria', dialingCode: 43 },
  { isoCode: 'AZ', label: 'Azerbaijan', dialingCode: 994 },
  { isoCode: 'BS', label: 'Bahamas', dialingCode: 1242 },
  { isoCode: 'BH', label: 'Bahrain', dialingCode: 973 },
  { isoCode: 'BD', label: 'Bangladesh', dialingCode: 880 },
  { isoCode: 'BB', label: 'Barbados', dialingCode: 1246 },
  { isoCode: 'BY', label: 'Belarus', dialingCode: 375 },
  { isoCode: 'BE', label: 'Belgium', dialingCode: 32 },
  { isoCode: 'BZ', label: 'Belize', dialingCode: 501 },
  { isoCode: 'BJ', label: 'Benin', dialingCode: 229 },
  { isoCode: 'BM', label: 'Bermuda', dialingCode: 1441 },
  { isoCode: 'BT', label: 'Bhutan', dialingCode: 975 },
  { isoCode: 'BO', label: 'Bolivia (Plurinational State of)', dialingCode: 591 },
  { isoCode: 'BQ', label: 'Bonaire, Sint Eustatius and Saba', dialingCode: 488 },
  { isoCode: 'BA', label: 'Bosnia and Herzegovina', dialingCode: 387 },
  { isoCode: 'BW', label: 'Botswana', dialingCode: 267 },
  { isoCode: 'BV', label: 'Bouvet Island', dialingCode: 55 },
  { isoCode: 'BR', label: 'Brazil', dialingCode: 55 },
  { isoCode: 'IO', label: 'British Indian Ocean Territory', dialingCode: 246 },
  { isoCode: 'BN', label: 'Brunei Darussalam', dialingCode: 673 },
  { isoCode: 'BG', label: 'Bulgaria', dialingCode: 359 },
  { isoCode: 'BF', label: 'Burkina Faso', dialingCode: 226 },
  { isoCode: 'BI', label: 'Burundi', dialingCode: 257 },
  { isoCode: 'KH', label: 'Cambodia', dialingCode: 855 },
  { isoCode: 'CM', label: 'Cameroon', dialingCode: 237 },
  { isoCode: 'CA', label: 'Canada', dialingCode: 1 },
  { isoCode: 'CV', label: 'Cape Verde', dialingCode: 238 },
  { isoCode: 'KY', label: 'Cayman Islands', dialingCode:  345 },
  { isoCode: 'CF', label: 'Central African Republic', dialingCode: 236 },
  { isoCode: 'TD', label: 'Chad', dialingCode: 235 },
  { isoCode: 'CL', label: 'Chile', dialingCode: 56 },
  { isoCode: 'CN', label: 'China', dialingCode: 86 },
  { isoCode: 'CX', label: 'Christmas Island', dialingCode: 61 },
  { isoCode: 'CC', label: 'Cocos (Keeling) Islands', dialingCode: 61 },
  { isoCode: 'CO', label: 'Colombia', dialingCode: 57 },
  { isoCode: 'KM', label: 'Comoros', dialingCode: 269 },
  { isoCode: 'CG', label: 'Congo', dialingCode: 242 },
  { isoCode: 'CD', label: 'Congo (the Democratic Republic of the)', dialingCode: 243 },
  { isoCode: 'CK', label: 'Cook Islands', dialingCode: 682 },
  { isoCode: 'CR', label: 'Costa Rica', dialingCode: 506 },
  { isoCode: 'CI', label: 'Cote d\'Ivoire', dialingCode: 225 },
  { isoCode: 'HR', label: 'Croatia', dialingCode: 385 },
  { isoCode: 'CU', label: 'Cuba', dialingCode: 53 },
  { isoCode: 'CW', label: 'Curaçao', dialingCode: 599 },
  { isoCode: 'CY', label: 'Cyprus', dialingCode: 357 },
  { isoCode: 'CZ', label: 'Czech Republic', dialingCode: 420 },
  { isoCode: 'DK', label: 'Denmark', dialingCode: 45 },
  { isoCode: 'DJ', label: 'Djibouti', dialingCode: 253 },
  { isoCode: 'DM', label: 'Dominica', dialingCode: 1767 },
  { isoCode: 'DO', label: 'Dominican Republic', dialingCode: 1849 },
  { isoCode: 'EC', label: 'Ecuador', dialingCode: 593 },
  { isoCode: 'EG', label: 'Egypt', dialingCode: 20 },
  { isoCode: 'SV', label: 'El Salvador', dialingCode: 503 },
  { isoCode: 'GQ', label: 'Equatorial Guinea', dialingCode: 240 },
  { isoCode: 'ER', label: 'Eritrea', dialingCode: 291 },
  { isoCode: 'EE', label: 'Estonia', dialingCode: 372 },
  { isoCode: 'SZ', label: 'Eswatini', dialingCode: 268 },
  { isoCode: 'ET', label: 'Ethiopia', dialingCode: 251 },
  { isoCode: 'FK', label: 'Falkland Islands (Malvinas)', dialingCode: 500 },
  { isoCode: 'FO', label: 'Faroe Islands', dialingCode: 298 },
  { isoCode: 'FJ', label: 'Fiji', dialingCode: 679 },
  { isoCode: 'FI', label: 'Finland', dialingCode: 358 },
  { isoCode: 'FR', label: 'France', dialingCode: 33 },
  { isoCode: 'GF', label: 'French Guiana', dialingCode: 594 },
  { isoCode: 'PF', label: 'French Polynesia', dialingCode: 689 },
  { isoCode: 'TF', label: 'French Southern Territories', dialingCode: 262 },
  { isoCode: 'GA', label: 'Gabon', dialingCode: 241 },
  { isoCode: 'GM', label: 'Gambia', dialingCode: 220 },
  { isoCode: 'GE', label: 'Georgia', dialingCode: 995 },
  { isoCode: 'DE', label: 'Germany', dialingCode: 49 },
  { isoCode: 'GH', label: 'Ghana', dialingCode: 233 },
  { isoCode: 'GI', label: 'Gibraltar', dialingCode: 350 },
  { isoCode: 'GR', label: 'Greece', dialingCode: 30 },
  { isoCode: 'GL', label: 'Greenland', dialingCode: 299 },
  { isoCode: 'GD', label: 'Grenada', dialingCode: 1473 },
  { isoCode: 'GP', label: 'Guadeloupe', dialingCode: 590 },
  { isoCode: 'GU', label: 'Guam', dialingCode: 1671 },
  { isoCode: 'GT', label: 'Guatemala', dialingCode: 502 },
  { isoCode: 'GG', label: 'Guernsey', dialingCode: 44 },
  { isoCode: 'GN', label: 'Guinea', dialingCode: 224 },
  { isoCode: 'GW', label: 'Guinea-Bissau', dialingCode: 245 },
  { isoCode: 'GY', label: 'Guyana', dialingCode: 595 },
  { isoCode: 'HT', label: 'Haiti', dialingCode: 509 },
  { isoCode: 'HM', label: 'Heard Island and McDonald Islands', dialingCode: 672 },
  { isoCode: 'VA', label: 'Holy See (Vatican City State)', dialingCode: 379 },
  { isoCode: 'HN', label: 'Honduras', dialingCode: 504 },
  { isoCode: 'HK', label: 'Hong Kong', dialingCode: 852 },
  { isoCode: 'HU', label: 'Hungary', dialingCode: 36 },
  { isoCode: 'IS', label: 'Iceland', dialingCode: 354 },
  { isoCode: 'IN', label: 'India', dialingCode: 91 },
  { isoCode: 'ID', label: 'Indonesia', dialingCode: 62 },
  { isoCode: 'IR', label: 'Iran (Islamic Republic of)', dialingCode: 98 },
  { isoCode: 'IQ', label: 'Iraq', dialingCode: 964 },
  { isoCode: 'IE', label: 'Ireland', dialingCode: 353 },
  { isoCode: 'IM', label: 'Isle of Man', dialingCode: 44 },
  { isoCode: 'IL', label: 'Israel', dialingCode: 972 },
  { isoCode: 'IT', label: 'Italy', dialingCode: 39 },
  { isoCode: 'JM', label: 'Jamaica', dialingCode: 1876 },
  { isoCode: 'JP', label: 'Japan', dialingCode: 81 },
  { isoCode: 'JE', label: 'Jersey', dialingCode: 44 },
  { isoCode: 'JO', label: 'Jordan', dialingCode: 962 },
  { isoCode: 'KZ', label: 'Kazakhstan', dialingCode: 7 },
  { isoCode: 'KE', label: 'Kenya', dialingCode: 254 },
  { isoCode: 'KI', label: 'Kiribati', dialingCode: 686 },
  { isoCode: 'KP', label: 'Korea, Democratic People\'s Republic of Korea', dialingCode: 850 },
  { isoCode: 'KR', label: 'Korea, Republic of South Korea', dialingCode: 82 },
  { isoCode: 'KW', label: 'Kuwait', dialingCode: 965 },
  { isoCode: 'KG', label: 'Kyrgyzstan', dialingCode: 996 },
  { isoCode: 'LA', label: 'Laos', dialingCode: 856 },
  { isoCode: 'LV', label: 'Latvia', dialingCode: 371 },
  { isoCode: 'LB', label: 'Lebanon', dialingCode: 961 },
  { isoCode: 'LS', label: 'Lesotho', dialingCode: 266 },
  { isoCode: 'LR', label: 'Liberia', dialingCode: 231 },
  { isoCode: 'LY', label: 'Libya', dialingCode: 218 },
  { isoCode: 'LI', label: 'Liechtenstein', dialingCode: 423 },
  { isoCode: 'LT', label: 'Lithuania', dialingCode: 370 },
  { isoCode: 'LU', label: 'Luxembourg', dialingCode: 352 },
  { isoCode: 'MO', label: 'Macao', dialingCode: 853 },
  { isoCode: 'MK', label: 'Macedonia', dialingCode: 389 },
  { isoCode: 'MG', label: 'Madagascar', dialingCode: 261 },
  { isoCode: 'MW', label: 'Malawi', dialingCode: 265 },
  { isoCode: 'MY', label: 'Malaysia', dialingCode: 60 },
  { isoCode: 'MV', label: 'Maldives', dialingCode: 960 },
  { isoCode: 'ML', label: 'Mali', dialingCode: 223 },
  { isoCode: 'MT', label: 'Malta', dialingCode: 356 },
  { isoCode: 'MH', label: 'Marshall Islands', dialingCode: 692 },
  { isoCode: 'MQ', label: 'Martinique', dialingCode: 596 },
  { isoCode: 'MR', label: 'Mauritania', dialingCode: 222 },
  { isoCode: 'MU', label: 'Mauritius', dialingCode: 230 },
  { isoCode: 'YT', label: 'Mayotte', dialingCode: 262 },
  { isoCode: 'MX', label: 'Mexico', dialingCode: 52 },
  { isoCode: 'FM', label: 'Micronesia (Federated States of)', dialingCode: 691 },
  { isoCode: 'MD', label: 'Moldova (the Republic of)', dialingCode: 373 },
  { isoCode: 'MC', label: 'Monaco', dialingCode: 377 },
  { isoCode: 'MN', label: 'Mongolia', dialingCode: 976 },
  { isoCode: 'ME', label: 'Montenegro', dialingCode: 382 },
  { isoCode: 'MS', label: 'Montserrat', dialingCode: 1664 },
  { isoCode: 'MA', label: 'Morocco', dialingCode: 212 },
  { isoCode: 'MZ', label: 'Mozambique', dialingCode: 258 },
  { isoCode: 'MM', label: 'Myanmar', dialingCode: 95 },
  { isoCode: 'NA', label: 'Namibia', dialingCode: 264 },
  { isoCode: 'NR', label: 'Nauru', dialingCode: 674 },
  { isoCode: 'NP', label: 'Nepal', dialingCode: 977 },
  { isoCode: 'NL', label: 'Netherlands', dialingCode: 31 },
  { isoCode: 'AN', label: 'Netherlands Antilles', dialingCode: 599 },
  { isoCode: 'NC', label: 'New Caledonia', dialingCode: 687 },
  { isoCode: 'NZ', label: 'New Zealand', dialingCode: 64 },
  { isoCode: 'NI', label: 'Nicaragua', dialingCode: 505 },
  { isoCode: 'NE', label: 'Niger', dialingCode: 227 },
  { isoCode: 'NG', label: 'Nigeria', dialingCode: 234 },
  { isoCode: 'NU', label: 'Niue', dialingCode: 683 },
  { isoCode: 'NF', label: 'Norfolk Island', dialingCode: 672 },
  { isoCode: 'MP', label: 'Northern Mariana Islands', dialingCode: 1670 },
  { isoCode: 'NO', label: 'Norway', dialingCode: 47 },
  { isoCode: 'OM', label: 'Oman', dialingCode: 968 },
  { isoCode: 'PK', label: 'Pakistan', dialingCode: 92 },
  { isoCode: 'PW', label: 'Palau', dialingCode: 680 },
  { isoCode: 'PS', label: 'Palestine, State of', dialingCode: 970 },
  { isoCode: 'PA', label: 'Panama', dialingCode: 507 },
  { isoCode: 'PG', label: 'Papua New Guinea', dialingCode: 675 },
  { isoCode: 'PY', label: 'Paraguay', dialingCode: 595 },
  { isoCode: 'PE', label: 'Peru', dialingCode: 51 },
  { isoCode: 'PH', label: 'Philippines', dialingCode: 63 },
  { isoCode: 'PN', label: 'Pitcairn', dialingCode: 872 },
  { isoCode: 'PL', label: 'Poland', dialingCode: 48 },
  { isoCode: 'PT', label: 'Portugal', dialingCode: 351 },
  { isoCode: 'PR', label: 'Puerto Rico', dialingCode: 1939 },
  { isoCode: 'QA', label: 'Qatar', dialingCode: 974 },
  { isoCode: 'RO', label: 'Romania', dialingCode: 40 },
  { isoCode: 'RU', label: 'Russia', dialingCode: 7 },
  { isoCode: 'RW', label: 'Rwanda', dialingCode: 250 },
  { isoCode: 'RE', label: 'Reunion', dialingCode: 262 },
  { isoCode: 'BL', label: 'Saint Barthelemy', dialingCode: 590 },
  { isoCode: 'SH', label: 'Saint Helena, Ascension and Tristan Da Cunha', dialingCode: 290 },
  { isoCode: 'KN', label: 'Saint Kitts and Nevis', dialingCode: 1869 },
  { isoCode: 'LC', label: 'Saint Lucia', dialingCode: 1758 },
  { isoCode: 'MF', label: 'Saint Martin (French part)', dialingCode: 590 },
  { isoCode: 'PM', label: 'Saint Pierre and Miquelon', dialingCode: 508 },
  { isoCode: 'VC', label: 'Saint Vincent and the Grenadines', dialingCode: 1784 },
  { isoCode: 'WS', label: 'Samoa', dialingCode: 685 },
  { isoCode: 'SM', label: 'San Marino', dialingCode: 378 },
  { isoCode: 'ST', label: 'Sao Tome and Principe', dialingCode: 239 },
  { isoCode: 'SA', label: 'Saudi Arabia', dialingCode: 966 },
  { isoCode: 'SN', label: 'Senegal', dialingCode: 221 },
  { isoCode: 'RS', label: 'Serbia', dialingCode: 381 },
  { isoCode: 'SC', label: 'Seychelles', dialingCode: 248 },
  { isoCode: 'SL', label: 'Sierra Leone', dialingCode: 232 },
  { isoCode: 'SX', label: 'Sint Maarten (Dutch part)', dialingCode: 721 },
  { isoCode: 'SG', label: 'Singapore', dialingCode: 65 },
  { isoCode: 'SK', label: 'Slovakia', dialingCode: 421 },
  { isoCode: 'SI', label: 'Slovenia', dialingCode: 386 },
  { isoCode: 'SB', label: 'Solomon Islands', dialingCode: 677 },
  { isoCode: 'SO', label: 'Somalia', dialingCode: 252 },
  { isoCode: 'ZA', label: 'South Africa', dialingCode: 27 },
  { isoCode: 'SS', label: 'South Sudan', dialingCode: 211 },
  { isoCode: 'GS', label: 'South Georgia and the South Sandwich Islands', dialingCode: 500 },
  { isoCode: 'ES', label: 'Spain', dialingCode: 34 },
  { isoCode: 'LK', label: 'Sri Lanka', dialingCode: 94 },
  { isoCode: 'SD', label: 'Sudan', dialingCode: 249 },
  { isoCode: 'SR', label: 'Suriname', dialingCode: 597 },
  { isoCode: 'SJ', label: 'Svalbard and Jan Mayen', dialingCode: 47 },
  { isoCode: 'SE', label: 'Sweden', dialingCode: 46 },
  { isoCode: 'CH', label: 'Switzerland', dialingCode: 41 },
  { isoCode: 'SY', label: 'Syrian Arab Republic', dialingCode: 963 },
  { isoCode: 'TW', label: 'Taiwan', dialingCode: 886 },
  { isoCode: 'TJ', label: 'Tajikistan', dialingCode: 992 },
  { isoCode: 'TZ', label: 'Tanzania (United Republic of)', dialingCode: 255 },
  { isoCode: 'TH', label: 'Thailand', dialingCode: 66 },
  { isoCode: 'TL', label: 'Timor-Leste', dialingCode: 670 },
  { isoCode: 'TG', label: 'Togo', dialingCode: 228 },
  { isoCode: 'TK', label: 'Tokelau', dialingCode: 690 },
  { isoCode: 'TO', label: 'Tonga', dialingCode: 676 },
  { isoCode: 'TT', label: 'Trinidad and Tobago', dialingCode: 1868 },
  { isoCode: 'TN', label: 'Tunisia', dialingCode: 216 },
  { isoCode: 'TR', label: 'Turkey', dialingCode: 90 },
  { isoCode: 'TM', label: 'Turkmenistan', dialingCode: 993 },
  { isoCode: 'TC', label: 'Turks and Caicos Islands', dialingCode: 1649 },
  { isoCode: 'TV', label: 'Tuvalu', dialingCode: 688 },
  { isoCode: 'UG', label: 'Uganda', dialingCode: 256 },
  { isoCode: 'UA', label: 'Ukraine', dialingCode: 380 },
  { isoCode: 'AE', label: 'United Arab Emirates', dialingCode: 971 },
  { isoCode: 'GB', label: 'United Kingdom', dialingCode: 44 },
  { isoCode: 'UM', label: 'United States Minor Outlying Islands', dialingCode: 1 },
  { isoCode: 'UY', label: 'Uruguay', dialingCode: 598 },
  { isoCode: 'UZ', label: 'Uzbekistan', dialingCode: 998 },
  { isoCode: 'VU', label: 'Vanuatu', dialingCode: 678 },
  { isoCode: 'VE', label: 'Venezuela (Bolivarian Republic of)', dialingCode: 58 },
  { isoCode: 'VN', label: 'Vietnam', dialingCode: 84 },
  { isoCode: 'VG', label: 'Virgin Islands (British)', dialingCode: 1284 },
  { isoCode: 'VI', label: 'Virgin Islands (U.S.)', dialingCode: 1340 },
  { isoCode: 'WF', label: 'Wallis and Futuna', dialingCode: 681 },
  { isoCode: 'EH', label: 'Western Sahara', dialingCode: 212 },
  { isoCode: 'YE', label: 'Yemen', dialingCode: 967 },
  { isoCode: 'ZM', label: 'Zambia', dialingCode: 260 },
  { isoCode: 'ZW', label: 'Zimbabwe', dialingCode: 263 },
] as Country[]
